// extracted by mini-css-extract-plugin
export default {"mobile-nav":"styles__mobile-nav--5yvBh"};